import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import filesStore from 'modules/documents/components/Documents/store'
import { useEmployeePictures } from 'modules/employees/components/blocks/FaceRecognition/EmployeePicturesContext'

interface FooterProps {
  form: Form
  close: () => void
}

const FooterUploadForm = ({ form, close }: FooterProps) => {
  const employeePictures = useEmployeePictures()

  const getEmployeeId = () => (form.has('employee_id') ? form.get('employee_id').value : null)

  const onSubmit = async () => {
    const { success } = await asyncAction(() =>
      employeePictures.create({
        picture: filesStore.files[0],
        employee_id: getEmployeeId(),
      })
    )

    if (success) {
      filesStore.files = []
      close()
    }
  }

  return (
    <Button onClick={onSubmit}>{i18n.t('employee_form.face_recognition_info.modal_submit')}</Button>
  )
}

export default observer(FooterUploadForm)
